import A2 from "modules/ebiForms/definitions/A2";
import A4 from "modules/ebiForms/definitions/A4";
import A9 from "modules/ebiForms/definitions/A9";
import B1 from "modules/ebiForms/definitions/B1";
import B9 from "modules/ebiForms/definitions/B9";
import B10 from "modules/ebiForms/definitions/B10";
import EDUCATION_SAFETY from "modules/ebiForms/definitions/groupEducationSafety";
import FAMILY_LABOUR from "modules/ebiForms/definitions/groupFamilyLabour";
import GEODESY_ENVIRONMENT from "modules/ebiForms/definitions/groupGeodesyEnvironment";
import HOUSING from "modules/ebiForms/definitions/groupHousing";
import MUNICIPAL_SERVICES from "modules/ebiForms/definitions/groupMunicipalServices";
import PLANNING_TAXES from "modules/ebiForms/definitions/groupPlanningTaxes";
import ROADS from "modules/ebiForms/definitions/groupRoads";
import SOCIAL from "modules/ebiForms/definitions/groupSocial";
import VEHICLES_CONSTRUCTION from "modules/ebiForms/definitions/groupVehiclesConstruction";
import { EEbiFormCategory, EEbiFormOffice, IEbiFormDefinition } from "modules/ebiForms/typings";

const byCode = (a: IEbiFormDefinition, b: IEbiFormDefinition) => a.code.localeCompare(b.code, "pl", { numeric: true });

/**
 * Wszystkie pozycje katalogu docs/magistrat/ebi-wnioski (79 postępowań). Wnioski składane przez EBI muszą istnieć
 * w katalogu BE (Kwantum.LegalMail.Data/Ebi/EbiSubmissionDtos.cs → EbiFormCatalog); sprawy załatwiane w innych systemach
 * (`external`) tylko odsyłają petenta.
 */
export const EBI_FORMS: IEbiFormDefinition[] = [
  A2,
  A4,
  A9,
  B1,
  B9,
  B10,
  ...PLANNING_TAXES,
  ...HOUSING,
  ...MUNICIPAL_SERVICES,
  ...ROADS,
  ...SOCIAL,
  ...EDUCATION_SAFETY,
  ...VEHICLES_CONSTRUCTION,
  ...GEODESY_ENVIRONMENT,
  ...FAMILY_LABOUR,
].sort(byCode);

/** Kolejność grup w katalogu. */
export const EBI_FORM_CATEGORIES: EEbiFormCategory[] = [
  EEbiFormCategory.General,
  EEbiFormCategory.Community,
  EEbiFormCategory.Planning,
  EEbiFormCategory.Property,
  EEbiFormCategory.Construction,
  EEbiFormCategory.Geodesy,
  EEbiFormCategory.Taxes,
  EEbiFormCategory.Environment,
  EEbiFormCategory.Roads,
  EEbiFormCategory.Housing,
  EEbiFormCategory.Social,
  EEbiFormCategory.Disability,
  EEbiFormCategory.Education,
  EEbiFormCategory.Labour,
  EEbiFormCategory.Permits,
  EEbiFormCategory.Vehicles,
  EEbiFormCategory.Safety,
];

/** Kolejność części katalogu (ustawienia EBI → Wnioski). */
export const EBI_FORM_OFFICES: EEbiFormOffice[] = [
  EEbiFormOffice.Municipality,
  EEbiFormOffice.MunicipalUnit,
  EEbiFormOffice.County,
  EEbiFormOffice.CountyUnit,
];

/** Urząd, który nie wybrał wniosków w ustawieniach EBI, przyjmuje wnioski gminne (urząd gminy i jego jednostki). */
export const EBI_DEFAULT_OFFICES: EEbiFormOffice[] = [EEbiFormOffice.Municipality, EEbiFormOffice.MunicipalUnit];

export const findEbiForm = (code?: string) => EBI_FORMS.find((form) => form.code === code);
